/* global translation */
const miniWishListContainer = document.getElementById('mini-wishlist');

const maksimerCloseMiniWishlistSidebar = () => {
  jQuery('.close-mini-wishlist-modal').on('click', (e) => {
    e.preventDefault();
    jQuery('.mini-dropdown-list').animate({ right: -9999, opacity: 'hide' }, 300);
  });
};

jQuery(($) => {
  $('.toggle-mini-wishlist').on('click', (e) => {
    e.preventDefault();
    $('.mini-dropdown-list').animate({ right: 0, opacity: 'show' }, 300);
    $('.widget_shopping_cart').animate({ right: -9999, opacity: 'hide' }, 300);
  });
  maksimerCloseMiniWishlistSidebar();
});

const maksimerRefreshMiniWishlist = () => {
  jQuery.post(translation.ajaxurl, {
    action: 'maksimer_ajax_wishlist_refresh',
  }, (response) => {
    let data;
    try { data = jQuery.parseJSON(response); } catch (err) {
      console.log(`Problem parsing json string : ${response}`); // eslint-disable-line no-console
      return null;
    }
    jQuery('.wishlist-container-inner').replaceWith(data);
    maksimerCloseMiniWishlistSidebar();
    return null;
  });
};

jQuery(document).on('click', '#mini-wishlist ul.mini-dropdown-products a.remove-item', (event) => {
  event.preventDefault();
  const link = event.currentTarget;
  const { postId, wishlistId } = link.dataset;
  const confirmed = window.confirm(`${translation.delete_product} "${link.dataset.productName}"?`);

  if (!confirmed) {
    return;
  }

  miniWishListContainer.classList.add('wait');

  jQuery.post(translation.ajaxurl, { action: 'maksimer_ajax_wishlist_remove_item', wishlist_id: postId, post_id: postId }, () => {
    maksimerRefreshMiniWishlist();
    setTimeout(() => {
      miniWishListContainer.classList.remove('wait');
    }, 500);
  });
});


jQuery(document).on('click', '.product a.krokedil-wishlist, .wc-block-grid__product a.krokedil-wishlist', () => {
  maksimerRefreshMiniWishlist();
});
